import { useTranslation } from 'react-i18next'

import { Heading6 } from '@ui/Typography'
import { ArrowIcon } from '@ui/icons/Arrow.icon'

import styles from './SignupErrorStep.module.scss'

interface SignupErrorStepProps {
  goBack(): void
}

export const SignupErrorStep: React.FC<SignupErrorStepProps> = (props) => {
  const { goBack } = props

  const { t } = useTranslation()

  return (
    <section className={styles.stepsBox}>
      <span className={styles.backArrow} onClick={goBack}>
        <ArrowIcon.Left size={16} />
      </span>
      <Heading6 medium>{t('Sign up.Sign up')}</Heading6>
    </section>
  )
}
